import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/about-us/projects/")({
  head: () => buildRouteHead("/en/about-us/projects/", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/about-qbd/projects", replace: true });
  },
});
